import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as CloseBtn } from "../../../assets/icons/Icon.svg";
import { UPDATE_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import "moment/locale/az";
import "./style.css";
import moment from "moment-timezone";
import { useCustomHook } from "../../GlobalFunctions/globalFunctions";
import { changeStudentUpdatesStatusAction } from "../../../redux/actions/updatesActions";
import { useEffect } from "react";
import LoadingBtn from "../../Loading/components/LoadingBtn/LoadingBtn";

const UpdatesModalStudentDetails = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const { updatesModalData: modalData, isLoading: updatesModalLoading } =
    useSelector((state) => state.updatesModal);
  const { whereSendList } = useCustomHook();
  const [updateBtn, setUpdateBtn] = useState(false);
  const [confirmedBtn, setConfirmedBtn] = useState(false);

  const closeModal = () => {
    dispatch({
      type: UPDATE_MODAL_ACTION_TYPE.GET_UPDATES_MODAL,
      payload: { data: {}, openModal: false },
    });
  };

  const [activeStatus, setActiveStatus] = useState(
    modalData?.status || "pending"
  );

  const whereOldSendName = whereSendList.find(
    (item) => item.key === modalData?.oldData?.whereSend
  )?.name;

  const whereNewSendName = whereSendList.find(
    (item) => item.key === modalData?.newData?.whereSend
  )?.name;

  const changeUpdatesStatus = () => {
    if (modalData.status === "pending") {
      dispatch(
        changeStudentUpdatesStatusAction(modalData._id, {
          status: activeStatus,
        })
      );
    }
  };

  const renderAddedGroup = (group) => {
    return (
      <div
        key={group?._id}
        style={{
          margin: "0px 0px 40px 40px",
          padding: "10px",
          boxSizing: "border-box",
          backgroundColor: "#d4ffbf",
          borderRadius: "5px",
        }}
      >
        <h4>Qrup adı: {group?.group?.name} - Yeni əlavə olunan</h4>
        <p>
          Status:{" "}
          {group?.status === "continue"
            ? "Davam edir"
            : group?.status === "freeze"
            ? "Dondurdu"
            : group?.status === "graduate"
            ? "Məzun"
            : group?.status === "stopped"
            ? "Dayandırdı"
            : group?.status === "waiting"
            ? "Gözləmədə"
            : "Borclu məzun"}
        </p>
        {group?.status === "stopped" && (
          <p>
            Dayandırdığı tarix:{" "}
            {moment(group?.stoppedDate).tz("Asia/Baku").format("DD:MM:YYYY")}{" "}
          </p>
        )}
        {group?.status === "freeze" && (
          <p>
            Dondurduğu tarix:{" "}
            {moment(group?.freezeDate).tz("Asia/Baku").format("DD:MM:YYYY")}{" "}
          </p>
        )}
        <p>Təhsil dərəcəsi: {group?.degree} </p>
        <p>
          Müqavilə başlama tarixi:{" "}
          {moment(group?.contractStartDate)
            .tz("Asia/Baku")
            .format("DD:MM:YYYY")}{" "}
        </p>
        <p>
          Müqavilə bitmə tarixi:{" "}
          {moment(group?.contractEndDate).tz("Asia/Baku").format("DD:MM:YYYY")}{" "}
        </p>
        <p>Müqavilə nömrəsi: {group?.contractId} </p>
        <p>Ödəniş növü: {group?.payment?.paymentType} </p>
        <p>Məbləğ: {group?.amount} </p>
        <p>
          Endirim növü:{" "}
          {group?.discountReason === "technest"
            ? "Teknest"
            : group?.discountReason === "plus-card"
            ? "Tələbə plus kartı"
            : "Digər"}
        </p>
        <p>
          Endirim: {group?.discount}
          {group?.discount && "%"}
        </p>
        <p>Yekun məbləğ: {group?.totalAmount}</p>
        <p>
          Ödənişə başlama tarixi:{" "}
          {moment(group?.paymentStartDate).tz("Asia/Baku").format("DD:MM:YYYY")}
        </p>
        <p>Ödəniş hissəsi: {group?.paymentPart}</p>
        <h4> Ödənişlər:</h4>
        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          <p style={{ padding: "10px", border: "1px solid gray" }}>
            {!group?.payments ||
              (group?.payments.length === 0 && <p>ödəniş yoxdur</p>)}
            {group?.payments?.map((payment) => {
              return (
                <div
                  key={payment?._id}
                  style={{ marginLeft: "20px", borderBottom: "1px solid gray" }}
                >
                  <p>
                    Ödəmə tarixi:{" "}
                    {moment(payment?.paymentDate)
                      .tz("Asia/Baku")
                      .format("DD:MM:YYYY")}{" "}
                  </p>
                  <p>Ödəniş: {payment?.payment}AZN </p>
                </div>
              );
            })}
          </p>
        </div>
      </div>
    );
  };
  const renderDeletedGroup = (group) => {
    return (
      <div
        key={group?._id}
        style={{
          margin: "0px 0px 40px 40px",
          padding: "10px",
          boxSizing: "border-box",
          backgroundColor: "#ffced1",
          borderRadius: "5px",
        }}
      >
        <h4>Qrup adı: {group?.group?.name} - silindi</h4>

        <p>
          Status:{" "}
          {group?.status === "continue"
            ? "Davam edir"
            : group?.status === "freeze"
            ? "Dondurdu"
            : group?.status === "graduate"
            ? "Məzun"
            : group?.status === "stopped"
            ? "Dayandırdı"
            : group?.status === "waiting"
            ? "Gözləmədə"
            : "Borclu məzun"}
        </p>
        {group?.status === "stopped" && (
          <p>
            Dayandırdığı tarix:{" "}
            {moment(group?.stoppedDate).tz("Asia/Baku").format("DD:MM:YYYY")}{" "}
          </p>
        )}
        {group?.status === "freeze" && (
          <p>
            Dondurduğu tarix:{" "}
            {moment(group?.freezeDate).tz("Asia/Baku").format("DD:MM:YYYY")}{" "}
          </p>
        )}
        <p>Təhsil dərəcəsi: {group?.degree} </p>
        <p>
          Müqavilə başlama tarixi:{" "}
          {moment(group?.contractStartDate)
            .tz("Asia/Baku")
            .format("DD:MM:YYYY")}{" "}
        </p>
        <p>
          Müqavilə bitmə tarixi:{" "}
          {moment(group?.contractEndDate).tz("Asia/Baku").format("DD:MM:YYYY")}{" "}
        </p>
        <p>Müqavilə nömrəsi: {group?.contractId} </p>
        <p>Ödəniş növü: {group?.payment?.paymentType} </p>
        <p>Məbləğ: {group?.amount} </p>
        <p>
          Endirim növü:{" "}
          {group?.discountReason === "technest"
            ? "Teknest"
            : group?.discountReason === "plus-card"
            ? "Tələbə plus kartı"
            : "Digər"}
        </p>
        <p>
          Endirim: {group?.discount} {group?.discount && "%"}
        </p>
        <p>Yekun məbləğ: {group?.totalAmount}</p>
        <p>
          Ödənişə başlama tarixi:{" "}
          {moment(group?.paymentStartDate).tz("Asia/Baku").format("DD:MM:YYYY")}
        </p>
        <p>Ödəniş hissəsi: {group?.paymentPart}</p>

        <h4> Ödənişlər:</h4>
        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          <p style={{ padding: "10px", border: "1px solid gray" }}>
            {!group?.payments ||
              (group?.payments.length === 0 && <p>ödəniş yoxdur</p>)}
            {group?.payments?.map((payment) => {
              return (
                <div
                  key={payment?._id}
                  style={{ marginLeft: "20px", borderBottom: "1px solid gray" }}
                >
                  <p>
                    Ödəmə tarixi:{" "}
                    {moment(payment?.paymentDate)
                      .tz("Asia/Baku")
                      .format("DD:MM:YYYY")}{" "}
                  </p>
                  <p>Ödəniş: {payment?.payment}AZN </p>
                </div>
              );
            })}
          </p>
        </div>
      </div>
    );
  };
  const renderUpdatedGroup = (group) => {
    const newGroup = modalData.newData.groups.find(
      (item) => item.group._id === group.group._id
    );

    const oldPayements =
      group?.payments?.map((item) => ({
        paymentDate: item.paymentDate,
        payment: item.payment,
      })) || [];
    const newPayments =
      newGroup?.payments?.map((item) => ({
        paymentDate: item.paymentDate,
        payment: item.payment,
      })) || [];

    const oldPaymentsJson = JSON.stringify(oldPayements);
    const newPaymentsJson = JSON.stringify(newPayments);

    return (
      <div
        key={group?._id}
        style={{
          margin: "0px 0px 40px 40px",
          padding: "10px",
          boxSizing: "border-box",
          border: "1px solid gray",
          borderRadius: "5px",
        }}
      >
        <h4>
          Qrup adı: {group?.group?.name}{" "}
          {
            <span className={getChangedClass(group?.name, newGroup?.name)}>
              &#8594;
            </span>
          }{" "}
          <span className={getChangedClass(group?.name, newGroup?.name)}>
            {newGroup?.group?.name}
          </span>
        </h4>

        <p>
          Status:{" "}
          {group?.status === "continue"
            ? "Davam edir"
            : group?.status === "freeze"
            ? "Dondurdu"
            : group?.status === "graduate"
            ? "Məzun"
            : group?.status === "stopped"
            ? "Dayandırdı"
            : group?.status === "waiting"
            ? "Gözləmədə"
            : "Borclu məzun"}{" "}
          {
            <span className={getChangedClass(group?.status, newGroup?.status)}>
              &#8594;
            </span>
          }{" "}
          <span className={getChangedClass(group?.status, newGroup?.status)}>
            {newGroup?.status === "continue"
              ? "Davam edir"
              : newGroup?.status === "freeze"
              ? "Dondurdu"
              : newGroup?.status === "graduate"
              ? "Məzun"
              : newGroup?.status === "stopped"
              ? "Dayandırdı"
              : newGroup?.status === "waiting"
              ? "Gözləmədə"
              : "Borclu məzun"}
          </span>
        </p>
        {group?.status === "stopped" && (
          <p>
            Dayandırdığı tarix:{" "}
            {moment(group?.stoppedDate).tz("Asia/Baku").format("DD:MM:YYYY")}{" "}
            {
              <span
                className={getChangedClass(
                  group?.stoppedDate,
                  newGroup?.stoppedDate
                )}
              >
                &#8594;
              </span>
            }{" "}
            <span
              className={getChangedClass(
                group?.stoppedDate,
                newGroup?.stoppedDate
              )}
            >
              {" "}
              {moment(newGroup?.stoppedDate)
                .tz("Asia/Baku")
                .format("DD:MM:YYYY")}{" "}
            </span>
          </p>
        )}
        {group?.status === "freeze" && (
          <p>
            Dondurduğu tarix:{" "}
            {moment(group?.freezeDate).tz("Asia/Baku").format("DD:MM:YYYY")}{" "}
            {
              <span
                className={getChangedClass(
                  group?.freezeDate,
                  newGroup?.freezeDate
                )}
              >
                &#8594;
              </span>
            }{" "}
            <span
              className={getChangedClass(
                group?.freezeDate,
                newGroup?.freezeDate
              )}
            >
              {" "}
              {moment(newGroup?.freezeDate)
                .tz("Asia/Baku")
                .format("DD:MM:YYYY")}{" "}
            </span>
          </p>
        )}
        <p>
          Təhsil dərəcəsi: {group?.degree}{" "}
          {
            <span className={getChangedClass(group?.degree, newGroup?.degree)}>
              &#8594;
            </span>
          }{" "}
          <span className={getChangedClass(group?.degree, newGroup?.degree)}>
            {newGroup?.degree}{" "}
          </span>{" "}
        </p>
        <p>
          Müqavilə başlama tarixi:{" "}
          {moment(group?.contractStartDate)
            .tz("Asia/Baku")
            .format("DD:MM:YYYY")}{" "}
          {
            <span
              className={getChangedClass(
                group?.contractStartDate,
                newGroup?.contractStartDate
              )}
            >
              &#8594;
            </span>
          }{" "}
          <span
            className={getChangedClass(
              group?.contractStartDate,
              newGroup?.contractStartDate
            )}
          >
            {" "}
            {moment(newGroup?.contractStartDate)
              .tz("Asia/Baku")
              .format("DD:MM:YYYY")}{" "}
          </span>
        </p>
        <p>
          Müqavilə bitmə tarixi:{" "}
          {moment(group?.contractEndDate).tz("Asia/Baku").format("DD:MM:YYYY")}{" "}
          {
            <span
              className={getChangedClass(
                group?.contractEndDate,
                newGroup?.contractEndDate
              )}
            >
              &#8594;
            </span>
          }{" "}
          <span
            className={getChangedClass(
              group?.contractEndDate,
              newGroup?.contractEndDate
            )}
          >
            {" "}
            {moment(newGroup?.contractEndDate)
              .tz("Asia/Baku")
              .format("DD:MM:YYYY")}{" "}
          </span>
        </p>
        <p>
          Müqavilə nömrəsi: {group?.contractId}{" "}
          {
            <span
              className={getChangedClass(
                group?.contractId,
                newGroup?.contractId
              )}
            >
              &#8594;
            </span>
          }{" "}
          <span
            className={getChangedClass(group?.contractId, newGroup?.contractId)}
          >
            {newGroup?.contractId}{" "}
          </span>{" "}
        </p>
        <p>
          Ödəniş növü: {group?.payment?.paymentType}{" "}
          {
            <span
              className={getChangedClass(
                group?.payment?.paymentType,
                newGroup?.payment?.paymentType
              )}
            >
              &#8594;
            </span>
          }{" "}
          <span
            className={getChangedClass(
              group?.payment?.paymentType,
              newGroup?.payment?.paymentType
            )}
          >
            {newGroup?.payment?.paymentType}{" "}
          </span>{" "}
        </p>
        <p>
          Məbləğ: {group?.amount}{" "}
          {
            <span className={getChangedClass(group?.amount, newGroup?.amount)}>
              &#8594;
            </span>
          }{" "}
          <span className={getChangedClass(group?.amount, newGroup?.amount)}>
            {newGroup?.amount}{" "}
          </span>
        </p>
        <p>
          Endirim növü:{" "}
          {group?.discountReason === "technest"
            ? "Teknest"
            : group?.discountReason === "plus-card"
            ? "Tələbə plus kartı"
            : "Digər"}
          {
            <span
              className={getChangedClass(
                group?.discountReason,
                newGroup?.discountReason
              )}
            >
              &#8594;
            </span>
          }{" "}
          <span
            className={getChangedClass(
              group?.discountReason,
              newGroup?.discountReason
            )}
          >
            {" "}
            {newGroup?.discountReason === "technest"
              ? "Teknest"
              : newGroup?.discountReason === "plus-card"
              ? "Tələbə plus kartı"
              : "Digər"}
          </span>
        </p>

        <p>
          Endirim: {group?.discount}%{" "}
          {
            <span
              className={getChangedClass(group?.discount, newGroup?.discount)}
            >
              &#8594;
            </span>
          }{" "}
          <span
            className={getChangedClass(group?.discount, newGroup?.discount)}
          >
            {" "}
            {newGroup?.discount}%{" "}
          </span>
        </p>
        <p>
          Yekun məbləğ: {group?.totalAmount}{" "}
          {
            <span
              className={getChangedClass(
                group?.totalAmount,
                newGroup?.totalAmount
              )}
            >
              &#8594;
            </span>
          }{" "}
          <span
            className={getChangedClass(
              group?.totalAmount,
              newGroup?.totalAmount
            )}
          >
            {" "}
            {newGroup?.totalAmount}{" "}
          </span>
        </p>
        <p>
          Ödənişə başlama tarixi:{" "}
          {moment(group?.paymentStartDate).tz("Asia/Baku").format("DD:MM:YYYY")}
          {
            <span
              className={getChangedClass(
                group?.paymentStartDate,
                newGroup?.paymentStartDate
              )}
            >
              &#8594;
            </span>
          }{" "}
          <span
            className={getChangedClass(
              group?.paymentStartDate,
              newGroup?.paymentStartDate
            )}
          >
            {" "}
            {moment(newGroup?.paymentStartDate)
              .tz("Asia/Baku")
              .format("DD:MM:YYYY")}{" "}
          </span>
        </p>
        <p>
          Ödəniş hissəsi: {group?.paymentPart}{" "}
          {
            <span
              className={getChangedClass(
                group?.paymentPart,
                newGroup?.paymentPart
              )}
            >
              &#8594;
            </span>
          }{" "}
          <span
            className={getChangedClass(
              group?.paymentPart,
              newGroup?.paymentPart
            )}
          >
            {newGroup?.paymentPart}{" "}
          </span>{" "}
        </p>

        <h4> Ödənişlər:</h4>
        <div
          style={{
            display: "flex",
            marginLeft: "20px",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <p style={{ padding: "10px", border: "1px solid gray" }}>
            {!group?.payments ||
              (group?.payments.length === 0 && <p>ödəniş yoxdur</p>)}
            {group?.payments?.map((payment) => {
              return (
                <div
                  key={payment?._id}
                  style={{ borderBottom: "1px solid gray" }}
                >
                  <p>
                    Ödəmə tarixi:{" "}
                    {moment(payment?.paymentDate)
                      .tz("Asia/Baku")
                      .format("DD:MM:YYYY")}{" "}
                  </p>
                  <p>Ödəniş: {payment?.payment}AZN </p>
                </div>
              );
            })}
          </p>
          <span
            style={{
              color:
                oldPaymentsJson === newPaymentsJson ? "#2ecc71" : "#e74c3c",
            }}
          >
            &#8594;
          </span>
          <p
            style={{
              marginLeft: "30px",
              padding: "10px",
              backgroundColor:
                oldPaymentsJson === newPaymentsJson ? "#d4ffbf" : "#ffced1",
            }}
          >
            {!newGroup?.payments ||
              (newGroup?.payments.length === 0 && <p>ödəniş yoxdur</p>)}
            {newGroup?.payments?.map((payment, i) => {
              return (
                <div
                  key={payment?._id}
                  style={{
                    borderBottom: "1px solid gray",
                  }}
                >
                  <p>
                    Ödəmə tarixi:{" "}
                    {moment(payment?.paymentDate)
                      .tz("Asia/Baku")
                      .format("DD:MM:YYYY")}{" "}
                  </p>
                  <p>Ödəniş: {payment?.payment}AZN </p>
                </div>
              );
            })}
          </p>
        </div>
      </div>
    );
  };
  const renderGroup = (group) => {
    return (
      <div
        key={group?._id}
        style={{
          margin: "0px 0px 40px 40px",
          padding: "10px",
          boxSizing: "border-box",
          border: "1px solid gray",
          borderRadius: "5px",
        }}
      >
        <h4>Qrup adı: {group?.group?.name}</h4>

        <p>
          Status:{" "}
          {group?.status === "continue"
            ? "Davam edir"
            : group?.status === "freeze"
            ? "Dondurdu"
            : group?.status === "graduate"
            ? "Məzun"
            : group?.status === "stopped"
            ? "Dayandırdı"
            : group?.status === "waiting"
            ? "Gözləmədə"
            : "Borclu məzun"}
        </p>
        {group?.status === "stopped" && (
          <p>
            Dayandırdığı tarix:{" "}
            {moment(group?.stoppedDate).tz("Asia/Baku").format("DD:MM:YYYY")}
          </p>
        )}
        {group?.status === "freeze" && (
          <p>
            Dondurduğu tarix:{" "}
            {moment(group?.freezeDate).tz("Asia/Baku").format("DD:MM:YYYY")}
          </p>
        )}
        <p>Təhsil dərəcəsi: {group?.degree}</p>
        <p>
          Müqavilə başlama tarixi:{" "}
          {moment(group?.contractStartDate)
            .tz("Asia/Baku")
            .format("DD:MM:YYYY")}
        </p>
        <p>
          Müqavilə bitmə tarixi:{" "}
          {moment(group?.contractEndDate).tz("Asia/Baku").format("DD:MM:YYYY")}
        </p>
        <p>Müqavilə nömrəsi: {group?.contractId}</p>
        <p>Ödəniş növü: {group?.payment?.paymentType}</p>
        <p>Məbləğ: {group?.amount}</p>
        <p>
          Endirim növü:{" "}
          {group?.discountReason === "technest"
            ? "Teknest"
            : group?.discountReason === "plus-card"
            ? "Tələbə plus kartı"
            : "Digər"}
        </p>

        <p>Endirim: {group?.discount}%</p>
        <p>Yekun məbləğ: {group?.totalAmount}</p>
        <p>
          Ödənişə başlama tarixi:{" "}
          {moment(group?.paymentStartDate).tz("Asia/Baku").format("DD:MM:YYYY")}
        </p>
        <p>Ödəniş hissəsi: {group?.paymentPart}</p>

        <h4>Ödənişlər:</h4>
        <div
          style={{
            display: "flex",
            marginLeft: "20px",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <p style={{ padding: "10px", border: "1px solid gray" }}>
            {!group?.payments ||
              (group?.payments.length === 0 && <p>ödəniş yoxdur</p>)}
            {group?.payments?.map((payment) => {
              return (
                <div
                  key={payment?._id}
                  style={{ borderBottom: "1px solid gray" }}
                >
                  <p>
                    Ödəmə tarixi:{" "}
                    {moment(payment?.paymentDate)
                      .tz("Asia/Baku")
                      .format("DD:MM:YYYY")}{" "}
                  </p>
                  <p>Ödəniş: {payment?.payment}AZN </p>
                </div>
              );
            })}
          </p>
        </div>
      </div>
    );
  };

  const getChangedClass = (oldValue, newValue) => {
    return oldValue !== newValue ? "new-value-changed" : "old-value";
  };

  const renderUpdatedGroupsList = (groups) => {
    return groups ? groups.map((group) => renderUpdatedGroup(group)) : [];
  };
  const renderDeletedGroupsList = (groups) => {
    return groups ? groups.map((group) => renderDeletedGroup(group)) : [];
  };
  const renderAddedGroupsList = (groups) => {
    return groups ? groups.map((group) => renderAddedGroup(group)) : [];
  };
  const renderGroupsList = (groups) => {
    return groups ? groups.map((group) => renderGroup(group)) : [];
  };

  const updatedGroups = modalData?.oldData.groups?.filter((oldItem) =>
    modalData?.newData?.groups?.find(
      (newItem) => oldItem.group._id === newItem.group._id
    )
  );

  const deletedGroups = modalData?.oldData?.groups.filter(
    (oldItem) =>
      !modalData?.newData?.groups.find(
        (newItem) => oldItem.group._id === newItem.group._id
      )
  );

  const addedGroups = modalData?.newData?.groups.filter(
    (newItem) =>
      !modalData?.oldData?.groups?.find(
        (oldItem) => oldItem.group._id === newItem.group._id
      )
  );

  const updatedGroupsList = renderUpdatedGroupsList(updatedGroups);
  const deletedGroupsList = renderDeletedGroupsList(deletedGroups);
  const addedGroupsList = renderAddedGroupsList(addedGroups);
  const groupList = renderGroupsList(modalData.oldData.groups);

  const oldCourses =
    Array.isArray(modalData?.oldData?.courses) &&
    modalData?.oldData?.courses.length > 0
      ? modalData?.oldData.courses
          .map((course) => {
            return `${course?.name}`;
          })
          .join(", ")
      : "";

  const newCourses =
    Array.isArray(modalData?.newData?.courses) &&
    modalData?.newData?.courses.length > 0
      ? modalData?.newData.courses
          .map((course) => {
            return `${course?.name}`;
          })
          .join(", ")
      : "";

  const renderUpdateRow = (label, oldVal, newVal) => {
    const hasChanged = oldVal !== newVal;
    const arrowColor = hasChanged ? "#e74c3c" : "#2ecc71";

    return (
      <div className="update-row">
        <span className="updates-key">{label}:</span>
        <span className="update-value old">{oldVal}</span>
        {modalData.action === "update" && (
          <>
            <span className="update-arrow" style={{ color: arrowColor }}>
              &#8594;
            </span>
            <span className={`update-value new ${hasChanged ? "change" : ""} `}>
              {newVal}
            </span>
          </>
        )}
      </div>
    );
  };

  const renderUpdateGroupsRow = (label) => {
    return (
      <div className={`update-row groups`}>
        <div className="group-container">
          <span className="updates-key old">{label}:</span>

          <div className="update-value old group-render">
            {modalData.action === "delete" && groupList}
            {modalData.action === "update" && updatedGroupsList}
            {modalData.action === "update" && deletedGroupsList}
            {modalData.action === "update" && addedGroupsList}
          </div>
          <div></div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (user.role === "worker") {
      const power = user?.profiles?.find(
        (item) => item?.profile === "students"
      )?.power;

      if (power === "all" || power === "update") {
        setUpdateBtn(true);
      }

      if (power === "all") {
        setConfirmedBtn(true);
      }
    }
  }, [user]);

  return (
    <>
      <div className="updates-datas-container">
        <div className="updates-list">
          {renderUpdateRow(
            "Ad, Soyad",
            modalData?.oldData?.fullName,
            modalData?.newData?.fullName
          )}
          {renderUpdateRow(
            "Fin",
            modalData?.oldData?.fin,
            modalData?.newData?.fin
          )}
          {renderUpdateRow(
            "Seria",
            modalData?.oldData?.seria,
            modalData?.newData?.seria
          )}
          {renderUpdateRow(
            "Email",
            modalData?.oldData?.email,
            modalData?.newData?.email
          )}
          {renderUpdateRow(
            "Email",
            modalData?.oldData?.phone,
            modalData?.newData?.phone
          )}
          {renderUpdateRow(
            "Doğum tarixi",
            moment(modalData?.oldData?.birthday)
              .tz("Asia/Baku")
              .format("DD:MM:YYYY"),
            moment(modalData?.newData?.birthday)
              .tz("Asia/Baku")
              .format("DD:MM:YYYY")
          )}
          {renderUpdateRow(
            "Satış tipi",
            modalData?.oldData?.salesType,

            modalData?.newData?.salesType
          )}

          {renderUpdateRow(
            "Bizi haradan eşidiblər?",
            modalData?.oldData?.whereComing?.name,
            modalData?.newData?.whereComing?.name
          )}
          {renderUpdateRow(
            "Haradan gəliblər?",
            whereOldSendName,
            whereNewSendName
          )}

          {renderUpdateRow(
            "Kurslar",

            oldCourses,
            newCourses
          )}
          {renderUpdateGroupsRow("Qruplar")}
        </div>
      </div>
      {/* <div className="status-button-container">
        <button
          onClick={() => setActiveStatus("pending")}
          className={activeStatus === "pending" ? "active" : ""}
        >
          Gözləmədə
        </button>
        <button
          disabled={!confirmedBtn}
          onClick={() => setActiveStatus("confirmed")}
          className={activeStatus === "confirmed" ? "active" : ""}
          style={!confirmedBtn ? { cursor: "not-allowed" } : {}}
        >
          Təsdiqləndi
        </button>
        <button
          onClick={() => setActiveStatus("cancelled")}
          className={activeStatus === "cancelled" ? "active" : ""}
        >
          Ləğv edildi
        </button>
      </div> */}
      {/* {modalData.status === "pending" && updateBtn && (
        <div className="create-update-modal-btn">
          <button disabled={updatesModalLoading} onClick={changeUpdatesStatus}>
            {updatesModalLoading ? <LoadingBtn /> : "Yenilə"}
          </button>
        </div>
      )} */}
    </>
  );
};

export default UpdatesModalStudentDetails;
